module.exports = __webpack_public_path__ + "static/media/acemitadetrigo.c3781b23.png";